export default class EagerlyAccordion {
  constructor(root) {
    this.root = root;
    this.breakpoint = window.matchMedia(root.dataset.breakpoint);
    this.button = root.querySelector('[aria-expanded]');
    this.panel = root.querySelector(`#${this.button.getAttribute('aria-controls')}`);
    this.isOpen = this.button.getAttribute('aria-expanded') === 'true';

    this.init();
  }

  static instances = new WeakMap();

  init() {
    EagerlyAccordion.instances.set(this.root, this);

    this.panel.hidden = !this.isOpen;
    this.panel.setAttribute('role', 'region');
    this.panel.setAttribute('aria-labelledby', this.button.id);

    this.button.addEventListener('click', this.handleClick);
  }

  handleClick = () => {
    this.isOpen ? this.close() : this.open();
  }

  handleOnTransitionend = () => {
    this.panel.hidden = true;
  }

  open() {
    this.panel.hidden = false;
    this.panel.offsetHeight; // force reflow so the panel transition happens after hidden has changed
    this.button.setAttribute('aria-expanded', true);

    this.isOpen = true;
  }

  close() {
    this.button.setAttribute('aria-expanded', false);
    this.panel.addEventListener('transitionend', this.handleOnTransitionend, {once: true});

    this.isOpen = false;
  }

  unmount() {
    this.button.removeEventListener('click', this.handleClick);
    this.panel.removeEventListener('transitionend', this.handleOnTransitionend, true)
    this.button.setAttribute('aria-expanded', false);
    this.panel.hidden = false;
    this.panel.removeAttribute('role');
    this.panel.removeAttribute('aria-labelledby');
    this.isOpen = false;

    EagerlyAccordion.instances.delete(this.root);
  }
}
